<template>
	<Button @click="onClick" :size="size" :disabled="disabled">
		<template #icon>
			<IconClose :size="size" style="margin-right: 4px" />
		</template>
		<slot />
	</Button>
</template>

<script>
import Button from './Button.vue'
import IconClose from '../icon/IconClose.vue'
import ButtonMixin from './ButtonMixin.js'
export default {
	mixins: [ButtonMixin],
	components: {
		Button,
		IconClose
	}
}
</script>
